<template>
  <div class="mibile-wrapper">
    <Home-Header :navindex="0"></Home-Header>
    <Home-TabBar :navindex="0"></Home-TabBar>
    <Home-Swiper ></Home-Swiper>
     <!-- <Home-Activity ></Home-Activity> -->
    <Home-TopFrom ></Home-TopFrom>
    <Home-Technology ></Home-Technology>
    <hr>
    <Home-Lowprice ></Home-Lowprice>
    <hr>
    <Home-Flexiblecharge ></Home-Flexiblecharge>
    <hr>
    <Home-Businessphilosophy ></Home-Businessphilosophy>
    <Home-Paperlessprocesses ></Home-Paperlessprocesses>
    <Home-Teamfounders></Home-Teamfounders>
    <Home-QA></Home-QA>
    <hr>
    <a id="newBridge-mobile"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a>

  </div>
</template>

<script>
import '../../assets/css/mstyle.css'
import HomeHeader from '../mcommon/Header'
import HomeTabBar from '../mcommon/TabBar'
import HomeSwiper from '../mcommon/Swiper'
import HomeTopFrom from '../mcommon/TopFrom'
// import HomeActivity from './components/Activity'
import HomeTechnology from './components/Technology'
import HomeLowprice from './components/Lowprice'
import HomeFlexiblecharge from './components/Flexiblecharge'
import HomeBusinessphilosophy from './components/Businessphilosophy'
import HomePaperlessprocesses from './components/Paperlessprocesses'
import HomeTeamfounders from '../mcommon/Teamfounders'
import HomeQA from '../mcommon/QA'

export default {
  name: 'MHome',
  metaInfo: {
    // 这里的 title 会替换 title中的字符占位
    title: '企业代理记账-上海机巧科技有限公司'
  },
  components: {
    HomeHeader, HomeTabBar, HomeSwiper, HomeTopFrom, HomeTechnology, HomeLowprice, HomeFlexiblecharge, HomeBusinessphilosophy, HomePaperlessprocesses, HomeTeamfounders, HomeQA
  },
  data () {
    return {
      list1: [],
      list2: [],
      list3: [],
      bgf8f6f9: 'bgf8f6f9',
      bgfff: 'bgfff'

    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.content-wrapper{
  margin-top: 72px;
}
hr{
  height: 10px;
  width: 100%;
  background: #f8f6f9;
}

</style>



// WEBPACK FOOTER //
// src/pages/mhome/MHome.vue